
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta } from "/app/apps/mad/pages/index.vue?macro=true";
import { default as _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta } from "/app/apps/mad/pages/account/orders/[id].vue?macro=true";
import { default as ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta } from "/app/layers/base/pages/account/orders.vue?macro=true";
import { default as indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta } from "/app/apps/mad/pages/account/user/index.vue?macro=true";
import { default as resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta } from "/app/layers/base/pages/password/reset.vue?macro=true";
import { default as direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta } from "/app/apps/mad/pages/service/direct-order.vue?macro=true";
import { default as _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta } from "/app/apps/mad/pages/p/[slug]/[id].vue?macro=true";
import { default as _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta } from "/app/apps/mad/pages/magazine/[slug].vue?macro=true";
import { default as indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta } from "/app/apps/mad/pages/outfits/[slug]/index.vue?macro=true";
import { default as _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta } from "/app/apps/mad/pages/c/[...slug].vue?macro=true";
import { default as indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta } from "/app/apps/mad/pages/account/index.vue?macro=true";
import { default as basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta } from "/app/apps/mad/pages/basket.vue?macro=true";
import { default as checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta } from "/app/apps/mad/pages/checkout.vue?macro=true";
import { default as checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta } from "/app/apps/mad/pages/checkout_external_basket.vue?macro=true";
import { default as indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta } from "/app/apps/mad/pages/magazine/index.vue?macro=true";
import { default as indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta } from "/app/apps/mad/pages/outfits/index.vue?macro=true";
import { default as releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta } from "/app/layers/base/pages/releasetestpage.vue?macro=true";
import { default as searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta } from "/app/layers/base/pages/search.vue?macro=true";
import { default as signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta } from "/app/apps/mad/pages/signin.vue?macro=true";
import { default as successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta } from "/app/apps/mad/pages/success.vue?macro=true";
import { default as wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta } from "/app/apps/mad/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta } from "/app/layers/base/pages/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "account-orders___at",
    path: "/at/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___at",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___be",
    path: "/be/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___be",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fr-be",
    path: "/fr-be/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fr-be",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___ch",
    path: "/ch/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___ch",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fr-ch",
    path: "/fr-ch/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fr-ch",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___de",
    path: "/de/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___de",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fr",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___nl",
    path: "/nl/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___nl",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___uk",
    path: "/uk/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___uk",
    path: ":id()",
    meta: _91id_93fxo4Bwr7Iscnm7OYoQJpTCZackjjubWc6P6f34gBBYYMeta || {},
    component: () => import("/app/apps/mad/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-user___at",
    path: "/at/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___be",
    path: "/be/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___fr-be",
    path: "/fr-be/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___ch",
    path: "/ch/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___fr-ch",
    path: "/fr-ch/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___de",
    path: "/de/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___fr",
    path: "/fr/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___nl",
    path: "/nl/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "account-user___uk",
    path: "/uk/account/user",
    meta: indexnQd2kC19t_A46tPf_T5TE1oSf_QGZdUneWLckNwvxCcMeta || {},
    component: () => import("/app/apps/mad/pages/account/user/index.vue")
  },
  {
    name: "password-reset___at",
    path: "/at/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___be",
    path: "/be/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fr-be",
    path: "/fr-be/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___ch",
    path: "/ch/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fr-ch",
    path: "/fr-ch/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___nl",
    path: "/nl/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___uk",
    path: "/uk/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "service-direct-order___at",
    path: "/at/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___be",
    path: "/be/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fr-be",
    path: "/fr-be/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___ch",
    path: "/ch/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fr-ch",
    path: "/fr-ch/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___de",
    path: "/de/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fr",
    path: "/fr/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___nl",
    path: "/nl/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___uk",
    path: "/uk/service/direct-order",
    meta: direct_45orderzE_8yS5oauTROMZGtNid8u5VUpx60RVbgBiqThUxBqEMeta || {},
    component: () => import("/app/apps/mad/pages/service/direct-order.vue")
  },
  {
    name: "p-slug-id___at",
    path: "/at/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___be",
    path: "/be/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fr-be",
    path: "/fr-be/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___ch",
    path: "/ch/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fr-ch",
    path: "/fr-ch/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___de",
    path: "/de/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fr",
    path: "/fr/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___nl",
    path: "/nl/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___uk",
    path: "/uk/p/:slug()/:id()",
    meta: _91id_93I7FalJ5reXEl57ThhiA37oHedOuLTS5oE_M1rdnTvioMeta || {},
    component: () => import("/app/apps/mad/pages/p/[slug]/[id].vue")
  },
  {
    name: "magazine-slug___at",
    path: "/at/magazin/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___be",
    path: "/be/magazine/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fr-be",
    path: "/fr-be/magazine/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___ch",
    path: "/ch/magazin/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fr-ch",
    path: "/fr-ch/magazine/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___de",
    path: "/de/magazin/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fr",
    path: "/fr/magazine/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___nl",
    path: "/nl/magazine/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___uk",
    path: "/uk/magazine/:slug()",
    meta: _91slug_93UNIl5MaYfc2NFMkKWHhkTaI_T6HXq5g0C6EgIuz_U1IMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/[slug].vue")
  },
  {
    name: "outfits-slug___at",
    path: "/at/outfits/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___be",
    path: "/be/outfits/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fr-be",
    path: "/fr-be/ensembles/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___ch",
    path: "/ch/outfits/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fr-ch",
    path: "/fr-ch/ensembles/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___de",
    path: "/de/outfits/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fr",
    path: "/fr/ensembles/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___nl",
    path: "/nl/outfits/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___uk",
    path: "/uk/outfits/:slug()",
    meta: indexG1qESZQQH6JK_BwnyEB7k5PT_p_ZNs55DQGwzlH41qAMeta || {},
    component: () => import("/app/apps/mad/pages/outfits/[slug]/index.vue")
  },
  {
    name: "c-slug___at",
    path: "/at/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___be",
    path: "/be/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr-be",
    path: "/fr-be/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___ch",
    path: "/ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr-ch",
    path: "/fr-ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___de",
    path: "/de/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr",
    path: "/fr/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___nl",
    path: "/nl/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___uk",
    path: "/uk/c/:slug(.*)*",
    meta: _91_46_46_46slug_936ticOBa4dMNOxi34c88qTXrc__73iypmYB55qlMC3uYMeta || {},
    component: () => import("/app/apps/mad/pages/c/[...slug].vue")
  },
  {
    name: "account___at",
    path: "/at/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___be",
    path: "/be/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___fr-be",
    path: "/fr-be/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___ch",
    path: "/ch/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___fr-ch",
    path: "/fr-ch/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "account___uk",
    path: "/uk/account",
    meta: indexOtRIu1Sv04nJtOfXAgXlCKgkqvj_oipmwbQazqR809wMeta || {},
    component: () => import("/app/apps/mad/pages/account/index.vue")
  },
  {
    name: "basket___at",
    path: "/at/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___be",
    path: "/be/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___fr-be",
    path: "/fr-be/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___ch",
    path: "/ch/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___fr-ch",
    path: "/fr-ch/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___de",
    path: "/de/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___fr",
    path: "/fr/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___nl",
    path: "/nl/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "basket___uk",
    path: "/uk/basket",
    meta: basketg91D6K0IeTsApe0aSMbfezQAyIuFPpkXluQqA5A7cqsMeta || {},
    component: () => import("/app/apps/mad/pages/basket.vue")
  },
  {
    name: "checkout___at",
    path: "/at/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___be",
    path: "/be/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___fr-be",
    path: "/fr-be/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___ch",
    path: "/ch/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___fr-ch",
    path: "/fr-ch/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___nl",
    path: "/nl/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout___uk",
    path: "/uk/checkout",
    meta: checkoutPSpajRGT5z7l_hpxnjXdSpLmV_GpvXSskc1Ns_QMCTQMeta || {},
    component: () => import("/app/apps/mad/pages/checkout.vue")
  },
  {
    name: "checkout_external_basket___at",
    path: "/at/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___be",
    path: "/be/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fr-be",
    path: "/fr-be/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___ch",
    path: "/ch/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fr-ch",
    path: "/fr-ch/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___de",
    path: "/de/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fr",
    path: "/fr/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___nl",
    path: "/nl/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___uk",
    path: "/uk/checkout_external_basket",
    meta: checkout_external_basket5RvfC4riGmw0u64VqSVOSH7fVxekbu6MAXM_CGx_R_MMeta || {},
    component: () => import("/app/apps/mad/pages/checkout_external_basket.vue")
  },
  {
    name: "magazine___at",
    path: "/at/magazin",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___be",
    path: "/be/magazine",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___fr-be",
    path: "/fr-be/magazine",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___ch",
    path: "/ch/magazin",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___fr-ch",
    path: "/fr-ch/magazine",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___de",
    path: "/de/magazin",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___fr",
    path: "/fr/magazine",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___nl",
    path: "/nl/magazine",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "magazine___uk",
    path: "/uk/magazine",
    meta: indexcGQsmwDW_7zxQ8t5w4NautLJm4aiOxRRUaTYjbsoOBIMeta || {},
    component: () => import("/app/apps/mad/pages/magazine/index.vue")
  },
  {
    name: "outfits___at",
    path: "/at/outfits",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___be",
    path: "/be/outfits",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___fr-be",
    path: "/fr-be/ensembles",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___ch",
    path: "/ch/outfits",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___fr-ch",
    path: "/fr-ch/ensembles",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___de",
    path: "/de/outfits",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___fr",
    path: "/fr/ensembles",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___nl",
    path: "/nl/outfits",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "outfits___uk",
    path: "/uk/outfits",
    meta: indexautUglIX5dbOvzZiAwwLaPW4VD4ElRqfz9I5qaOmDN4Meta || {},
    component: () => import("/app/apps/mad/pages/outfits/index.vue")
  },
  {
    name: "releasetestpage___at",
    path: "/at/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___be",
    path: "/be/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fr-be",
    path: "/fr-be/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___ch",
    path: "/ch/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fr-ch",
    path: "/fr-ch/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___de",
    path: "/de/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fr",
    path: "/fr/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___nl",
    path: "/nl/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___uk",
    path: "/uk/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "search___at",
    path: "/at/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___be",
    path: "/be/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fr-be",
    path: "/fr-be/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___ch",
    path: "/ch/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fr-ch",
    path: "/fr-ch/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___uk",
    path: "/uk/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "signin___at",
    path: "/at/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___be",
    path: "/be/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___fr-be",
    path: "/fr-be/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___ch",
    path: "/ch/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___fr-ch",
    path: "/fr-ch/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___de",
    path: "/de/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___fr",
    path: "/fr/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___nl",
    path: "/nl/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "signin___uk",
    path: "/uk/signin",
    meta: signina_oyMy4pwKNZgxV3Yw725Dmoe8uOobEwT_TSnfoyfwkMeta || {},
    component: () => import("/app/apps/mad/pages/signin.vue")
  },
  {
    name: "success___at",
    path: "/at/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___be",
    path: "/be/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___fr-be",
    path: "/fr-be/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___ch",
    path: "/ch/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___fr-ch",
    path: "/fr-ch/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___de",
    path: "/de/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___fr",
    path: "/fr/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___nl",
    path: "/nl/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "success___uk",
    path: "/uk/success",
    meta: successKleFv1mTNAO2JDZz6Hj8dhJA_JclbrdZbgETtdz_5JEMeta || {},
    component: () => import("/app/apps/mad/pages/success.vue")
  },
  {
    name: "wishlist___at",
    path: "/at/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___be",
    path: "/be/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr-be",
    path: "/fr-be/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___ch",
    path: "/ch/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr-ch",
    path: "/fr-ch/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___de",
    path: "/de/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___nl",
    path: "/nl/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "wishlist___uk",
    path: "/uk/wishlist",
    meta: wishlistG3DkrLG_5OxgJ2yA6Dv6SyYVQLF5J_baBZf1mGOv5ooMeta || {},
    component: () => import("/app/apps/mad/pages/wishlist.vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fr-be",
    path: "/fr-be/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___ch",
    path: "/ch/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fr-ch",
    path: "/fr-ch/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "index___at",
    path: "/at",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___be",
    path: "/be",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___fr-be",
    path: "/fr-be",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___ch",
    path: "/ch",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___fr-ch",
    path: "/fr-ch",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexFNoOUu4lI4r0NEp_NK8Is97TH1H7_fowB38uIMuqGEIMeta || {},
    component: () => import("/app/apps/mad/pages/index.vue")
  }
]